// extracted by mini-css-extract-plugin
export default {"container":"feABW","title-section":"niG2Q","body-section":"dijKi"};